
"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { FunctionSquare, Menu, X } from "lucide-react";
import Link from "next/link";

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white border-b border-gray-100 px-6 py-4">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center space-x-2">
          <FunctionSquare className="w-8 h-8 text-orange-500" />
          <span className="text-2xl font-bold text-black">OneFunction</span>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          <Link href="#features" className="text-gray-600 hover:text-black transition-colors">
            Features
          </Link>
          <Link href="#how-it-works" className="text-gray-600 hover:text-black transition-colors">
            How it Works
          </Link>
          <Link href="#pricing" className="text-gray-600 hover:text-black transition-colors">
            Pricing
          </Link>
          <Link href="#docs" className="text-gray-600 hover:text-black transition-colors">
            Docs
          </Link>
          <Link href="#api" className="text-gray-600 hover:text-black transition-colors">
            API
          </Link>
          <Link href="#changelog" className="text-gray-600 hover:text-black transition-colors">
            Changelog
          </Link>
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center space-x-4">
          <Button variant="ghost" className="text-gray-600 hover:text-black">
            Sign In
          </Button>
          <Button className="bg-orange-500 text-white px-4 py-2 rounded-md hover:bg-orange-600 transition-colors">
            Subscribe
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? (
            <X className="w-6 h-6 text-gray-600" />
          ) : (
            <Menu className="w-6 h-6 text-gray-600" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden py-4 border-t border-gray-100">
          <nav className="flex flex-col space-y-4">
            <Link href="#features" className="text-gray-600 hover:text-black transition-colors">
              Features
            </Link>
            <Link href="#how-it-works" className="text-gray-600 hover:text-black transition-colors">
              How it Works
            </Link>
            <Link href="#pricing" className="text-gray-600 hover:text-black transition-colors">
              Pricing
            </Link>
            <Link href="#docs" className="text-gray-600 hover:text-black transition-colors">
              Docs
            </Link>
            <Link href="#api" className="text-gray-600 hover:text-black transition-colors">
              API
            </Link>
            <Link href="#changelog" className="text-gray-600 hover:text-black transition-colors">
              Changelog
            </Link>
            <div className="flex flex-col space-y-2 pt-4">
              <Button variant="ghost" className="text-gray-600 hover:text-black justify-start">
                Sign In
              </Button>
              <Button className="bg-orange-500 text-white hover:bg-orange-600 justify-start">
                Subscribe
              </Button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
      